import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { 
  ThemeProvider, 
  themeFantasticLlama,
  GlobalFontFace
} from '@match/react-component-library';
import ContainerQueryProvider from 'modules/components/ContainerQuery/ContainerQueryProvider';
import { IneligiblePage, LandingPage, PreLandingPage, RedeemPage, SuccessPage } from 'modules/pages';


interface State {
  name?: string
}

class App extends React.Component<{}, State> {
  state: State = {};

  handleNameChange = (name: string) => {
    this.setState({
      name
    });
  }

  render() {
    return (
      <BrowserRouter>
        <ThemeProvider theme={themeFantasticLlama}>
          <ContainerQueryProvider>
            <GlobalFontFace />
            <Route path={`${process.env.PUBLIC_URL}/`} exact component={PreLandingPage} />
            <Route path={`${process.env.PUBLIC_URL}/ineligible`} exact component={IneligiblePage} />
            <Route path={`${process.env.PUBLIC_URL}/landing`} exact component={LandingPage} />
            <Route path={`${process.env.PUBLIC_URL}/redeem`} exact
              render={(props) => <RedeemPage {...props} onNameChange={this.handleNameChange} />} />
            <Route path={`${process.env.PUBLIC_URL}/success`} exact
              render={(props) => <SuccessPage {...props} name={this.state.name} />}/>
          </ContainerQueryProvider>
        </ThemeProvider>
      </BrowserRouter>
    );
  }
}

export default App;
